<template>
  <div class="py-20 w-[90%] mx-auto relative">
    <div
      v-if="openSelectedModal"
      class="absolute z-50 top-0 left-0 right-0 bottom-0 bg-white/30 flex items-center justify-center h-screen"
      @click.self="closeEdit"
    >
      <div class="p-4 rounded-md bg-white shadow-lg border">
        <h2 class="text-2xl font-semibold">Edit {{ selectedSetting.name }}</h2>
        <div class="mb-4">
          <!-- <h3 class="text-lg font-bold"></h3> -->
          <p class="text-sm text-gray-600">{{ selectedSetting.description }}</p>
        </div>
        <div>
          <!-- <label
            for="settingValue"
            class="block text-sm font-medium text-gray-700"
            >Value</label
          > -->
          <input
            id="settingValue"
            type="number"
            v-model="selectedSetting.value"
            class="mt-1 py-2 px-4 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-green focus:border-green sm:text-sm"
          />
        </div>
        <div class="flex gap-2 items-stretch mt-6">
          <button
            class="w-1/2 px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
            @click="closeEdit"
          >
            Cancel
          </button>
          <button
            class="w-1/2 px-4 py-2 bg-realBlack text-white rounded-md"
            @click="submitEdit"
            :disabled="saving"
          >
            {{ saving ? "Saving..." : "Save" }}
          </button>
        </div>
      </div>
    </div>
    <div class="w-full">
      <h1 class="text-5xl font-semibold">Settings</h1>
      <div v-if="loading" class="w-full pt-40 flex items-center justify-center">
        <spinner />
      </div>
    </div>
    <div class="w-full mt-10">
      <!-- Change Password Section -->
      <div class="mb-12 max-w-md">
        <h2 class="text-2xl font-semibold mb-6">Change Password</h2>
        <div class="flex flex-col gap-4">
          <label class="block text-sm">
            Current Password
            <input
              type="password"
              v-model="changePassword.current_password"
              placeholder="Enter current password"
              class="block border text-sm border-gray-300 w-full rounded-lg py-3 px-4 mt-1 focus:outline-none focus:border-gray-500"
            />
          </label>
          <label class="block text-sm">
            New Password
            <input
              type="password"
              v-model="changePassword.new_password"
              placeholder="Enter new password"
              class="block border text-sm border-gray-300 w-full rounded-lg py-3 px-4 mt-1 focus:outline-none focus:border-gray-500"
            />
          </label>
          <label class="block text-sm">
            Confirm New Password
            <input
              type="password"
              v-model="changePassword.confirm_password"
              placeholder="Confirm new password"
              class="block border text-sm border-gray-300 w-full rounded-lg py-3 px-4 mt-1 focus:outline-none focus:border-gray-500"
            />
          </label>
          <p v-if="passwordError" class="text-red-500 text-sm">{{ passwordError }}</p>
          <p v-if="passwordSuccess" class="text-green-600 text-sm">{{ passwordSuccess }}</p>
          <button
            @click="submitChangePassword"
            :disabled="changingPassword"
            class="bg-realBlack text-white font-medium py-3 px-6 rounded-lg cursor-pointer disabled:opacity-50 transition-all w-full"
          >
            {{ changingPassword ? 'Changing...' : 'Change Password' }}
          </button>
        </div>
      </div>
      <hr class="border-gray-200 mb-10" />
      <h2 class="text-2xl font-semibold mb-6">General Settings</h2>
      <div class="grid xl:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-8">
        <div v-for="setting in settings" :key="setting.id">
          <h3 class="text-xl font-bold" :title="setting.description">
            {{ setting.name }}
          </h3>
          <div class="flex items-center gap-2 mt-2">
            <p>{{ setting.value }}</p>
            <button
              class="w-6 h-6 cursor-pointer border rounded-md p-1"
              title="Edit"
              @click="openEdit(JSON.parse(JSON.stringify(setting)))"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-full"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.862 3.487a2.25 2.25 0 113.182 3.182L7.5 19.213l-4.5 1.125 1.125-4.5L16.862 3.487z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner.vue";
export default {
  components: { Spinner },
  data() {
    return {
      loading: true,
      saving: false,
      settings: [],
      openSelectedModal: false,
      selectedSetting: {},
      changePassword: {
        current_password: "",
        new_password: "",
        confirm_password: "",
      },
      changingPassword: false,
      passwordError: "",
      passwordSuccess: "",
    };
  },
  methods: {
    async getSettings() {
      var payload = { path: "/admin/api/settings" };
      const response = await this.$store.dispatch("getRequest", payload);
      // console.log(response);

      this.settings = JSON.parse(JSON.stringify(response.data.data));

      this.loading = false;
    },
    openEdit(setting) {
      this.selectedSetting = setting;
      this.openSelectedModal = true;
    },
    closeEdit() {
      this.selectedSetting = {};
      this.openSelectedModal = false;
    },
    async submitEdit() {
      if (isNaN(this.selectedSetting.value)) {
        this.$toast.warn('The value must be a number.');
        return;
      }
      if (this.selectedSetting.value < 1 || this.selectedSetting.value > 100) {
        this.$toast.warn('The value must be between 1 and 100.');
        return;
      }
      this.saving = true;
      var payload = {
        path: "/admin/api/settings/" + this.selectedSetting.key,
        data: { value: this.selectedSetting?.value },
      };
      try {
        const response = await this.$store.dispatch("patchRequest", payload);

        const updatedSetting = response.data.data;
        // console.log(this.settings);

        const index = this.settings.findIndex(
          (setting) => setting.id === this.selectedSetting.id
        );
        if (index !== -1) {
          this.$set(this.settings, index, updatedSetting);
        }
        this.closeEdit();
        this.saving = false;
        this.$toast.success(response.data.message);
      } catch (error) {
        this.$toast.error('Something went wrong. Please try again.');
        console.error(error);
      }
    },
    async submitChangePassword() {
      this.passwordError = "";
      this.passwordSuccess = "";
      const { current_password, new_password, confirm_password } = this.changePassword;
      if (!current_password || !new_password || !confirm_password) {
        this.passwordError = "Please fill in all fields.";
        return;
      }
      if (new_password !== confirm_password) {
        this.passwordError = "New passwords do not match.";
        return;
      }
      this.changingPassword = true;
      try {
        const response = await this.$store.dispatch("postRequest", {
          path: "/admin/auth/change-password",
          data: { current_password, newPassword: new_password },
        });
        this.passwordSuccess = response.data.message || "Password changed successfully.";
        this.changePassword = { current_password: "", new_password: "", confirm_password: "" };
      } catch (error) {
        if (error.response) {
          this.passwordError = error.response.data.message || "Failed to change password.";
        } else {
          this.passwordError = "An error occurred. Please try again.";
        }
      } finally {
        this.changingPassword = false;
      }
    },
  },
  mounted() {
    this.getSettings();
  },
};
</script>

<style>
</style>